import { LeakStatus } from "@/api/types"

// 枚举类型颜色定义
export const ENUM_COLORS = {
  // DataScope 枚举颜色
  DataScope: {
    0: '#409EFF', // 全部
    1: '#67C23A', // 自定义
    2: '#E6A23C', // 部门
    3: '#F56C6C', // 部门及以下
    4: '#909399'  // 本人
  },

  // RecordStatus 枚举颜色
  RecordStatus: {
    0: '#F56C6C', // 禁用
    1: '#67C23A'  // 启用
  },

  // LeakStatus 枚举颜色
  LeakStatus: {
    0: '#909399', // 未上报 - 灰色
    1: '#E6A23C', // 待分配 - 黄色
    2: '#E6A23C', // 待认领 - 黄色（根据需求）
    3: '#409EFF', // 维修中 - 蓝色
    4: '#67C23A', // 完成维修 - 绿色
    5: '#F56C6C', // 无法维修 - 红色
    6: '#67C23A'  // 无需维修 - 绿色
  },

  // RepairType 枚举颜色
  RepairType: {
    0: '#909399', // 其他
    1: '#409EFF', // 表前
    2: '#67C23A', // 表后
    3: '#E6A23C', // 网外
    4: '#F56C6C'  // 挖空
  },

  // DeptType 枚举颜色
  DeptType: {
    0: '#909399', // 其他
    1: '#409EFF', // 检测
    2: '#67C23A'  // 维修
  }
}

// 漏点状态图标定义
export const LEAK_STATUS_ICONS = {
  0: 'el-icon-info',           // 未上报 - 灰色信息图标
  1: 'el-icon-warning',        // 待分配 - 黄色警告图标
  2: 'el-icon-time',           // 待认领 - 黄色时钟图标
  3: 'el-icon-loading',        // 维修中 - 蓝色加载图标
  4: 'el-icon-success',        // 完成维修 - 绿色成功图标
  5: 'el-icon-error',          // 无法维修 - 红色错误图标
  6: 'el-icon-check'           // 无需维修 - 绿色检查图标
}

export const LEAK_POINT_ICONS = {
  0: require('@/icons/svg/water-drop-gray.svg'), // 未上报
  1: require('@/icons/svg/water-drop-yellow.svg'), // 待分配
  2: require('@/icons/svg/water-drop-yellow.svg'), // 待认领
  3: require('@/icons/svg/water-drop-blue.svg'), // 维修中
  4: require('@/icons/svg/water-drop-green.svg'), // 完成维修
  5: require('@/icons/svg/water-drop-green.svg'), // 未能维修（改为绿色）
  6: require('@/icons/svg/water-drop-green.svg')  // 无需维修（改为绿色）
}

// 获取漏点状态颜色的辅助函数
export function GetLeakStatusColor(status: LeakStatus): string {
  return ENUM_COLORS.LeakStatus[status] || '#909399' // 默认灰色
}

// 获取漏点状态图标的辅助函数
export function GetLeakStatusIcon(status: LeakStatus): string {
  return LEAK_STATUS_ICONS[status] || 'el-icon-info' // 默认信息图标
}

// 获取漏点地图图标的辅助函数
export function GetLeakMapIcon(status: LeakStatus): string {
  return LEAK_POINT_ICONS[status] || LEAK_POINT_ICONS[0]
}